












import {Component, Prop, Mixins} from 'vue-property-decorator'
import Assets from '@/mixins/Assets'

type Menu = 'home' | 'tax' | 'invoice' | 'issue' | 'setting' | 'subsidy'

@Component
export default class MenuImg extends Mixins(Assets) {
  @Prop({default: '', type: String}) menu: Menu
  @Prop({default: 30, type: Number}) width: number

  get style() {
    return {
      width: `${this.width}px`,
    }
  }
}
